<template>
  <div class="container grades-view-container">
    <el-card shadow="hover">
      <template #header>
        <h2>عرض الدرجات المرصودة</h2>
      </template>
      
      <div class="filter-card">
        <el-row :gutter="20" align="bottom">
          <el-col :span="5">
            <label>السنة الدراسية</label>
            <el-select v-model="filters.study_year_id" placeholder="اختر السنة" @change="onStudyYearChange" clearable>
              <el-option v-for="year in meta.studyYears" :key="year.id" :label="year.name" :value="year.id" />
            </el-select>
          </el-col>
          <el-col :span="5">
            <label>المعلم</label>
            <el-select v-model="filters.teacher_id" filterable placeholder="اختر المعلم" @change="onTeacherChange" :disabled="!filters.study_year_id" clearable>
              <el-option v-for="teacher in meta.teachers" :key="teacher.id" :label="teacher.name" :value="teacher.id" />
            </el-select>
          </el-col>
          <el-col :span="5">
            <label>الفصل</label>
            <el-select v-model="filters.class_id" placeholder="اختر الفصل" @change="onClassChange" :disabled="!filters.teacher_id" clearable>
              <el-option v-for="cls in meta.classes" :key="cls.id" :label="cls.name" :value="cls.id" />
            </el-select>
          </el-col>
          <el-col :span="5">
            <label>الشعبة</label>
            <el-select v-model="filters.section_id" placeholder="اختر الشعبة" @change="onSectionChange" :disabled="!filters.class_id" clearable>
              <el-option v-for="sec in meta.sections" :key="sec.id" :label="sec.name" :value="sec.id" />
            </el-select>
          </el-col>
          <el-col :span="4">
            <label>المقرر</label>
            <el-select v-model="filters.course_offering_id" placeholder="اختر المقرر" @change="onCourseChange" :disabled="!filters.section_id" clearable>
              <el-option v-for="course in meta.courses" :key="course.id" :label="course.subject.name" :value="course.id" />
            </el-select>
          </el-col>
        </el-row>
      </div>

      <el-divider />

      <div class="actions-toolbar" v-if="gradesData.students.length > 0">
        <el-button @click="printGrades" type="primary" :icon="Printer">طباعة الكشف</el-button>
      </div>

      <div v-if="loading.grades" class="loading-placeholder">
        <p>جاري تحميل الدرجات...</p>
      </div>
      <div v-else-if="gradesData.students.length > 0">
        <el-table :data="gradesData.students" border style="width: 100%" show-summary>
          <el-table-column prop="name" label="اسم الطالب" fixed width="250" />
          <el-table-column
            v-for="assessment in gradesData.assessments"
            :key="assessment.id"
            :label="`${assessment.title} (${assessment.max_score})`"
            align="center"
          >
            <template #default="{ row }">
              <span>{{ row.scores[assessment.id] !== undefined ? row.scores[assessment.id] : '-' }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
       <div v-else-if="filters.course_offering_id" class="empty-placeholder">
        <p>لا توجد بيانات لعرضها. قد لا يكون هناك طلاب أو تقييمات لهذا المقرر.</p>
      </div>

    </el-card>
  </div>
</template>

<script>
import axios from 'axios';
import { ElMessage } from 'element-plus';
import { Printer } from '@element-plus/icons-vue';

export default {
  name: 'GradesView',
  components: { Printer },
  data() {
    return {
      api: null,
      filters: { study_year_id: null, teacher_id: null, class_id: null, section_id: null, course_offering_id: null },
      meta: { studyYears: [], teachers: [], classes: [], sections: [], courses: [] },
      gradesData: { assessments: [], students: [] },
      loading: { teachers: false, classes: false, sections: false, courses: false, grades: false },
    };
  },
  created() {
    this.api = axios.create({ baseURL: process.env.VUE_APP_API_BASE_URL || 'https://cale.caledonian.ly/api' });
    this.api.interceptors.request.use(config => {
      const token = localStorage.getItem('access_token');
      if (token) config.headers['Authorization'] = `Bearer ${token}`;
      return config;
    });
    this.fetchInitialFilters();
  },
  methods: {
    async fetchInitialFilters() {
      this.loading.teachers = true;
      try {
        const [teachersRes, yearsRes] = await Promise.all([
          this.api.get('/users', { params: { user_type: 'teacher' } }),
          this.api.get('/study-years')
        ]);
        this.meta.teachers = teachersRes.data.data;
        this.meta.studyYears = yearsRes.data.data || yearsRes.data;
      } catch (error) { ElMessage.error('فشل في جلب البيانات الأولية.'); } 
      finally { this.loading.teachers = false; }
    },
    onStudyYearChange() {
      this.filters.teacher_id = null;
      this.onTeacherChange();
    },
    async onTeacherChange() {
      this.filters.class_id = null; this.meta.classes = [];
      this.onClassChange();
      if (!this.filters.teacher_id || !this.filters.study_year_id) return;
      
      this.loading.classes = true;
      try {
        const response = await this.api.get(`/teachers/${this.filters.teacher_id}/classes`, {
            params: { study_year_id: this.filters.study_year_id }
        });
        this.meta.classes = response.data;
      } catch (error) { ElMessage.error('فشل في جلب الفصول.'); }
      finally { this.loading.classes = false; }
    },
    async onClassChange() {
      this.filters.section_id = null; this.meta.sections = [];
      this.onSectionChange();
      if (!this.filters.teacher_id || !this.filters.class_id) return;

      this.loading.sections = true;
      try {
        const response = await this.api.get(`/teachers/${this.filters.teacher_id}/classes/${this.filters.class_id}/sections`);
        this.meta.sections = response.data;
      } catch (error) { ElMessage.error('فشل في جلب الشعب.'); }
      finally { this.loading.sections = false; }
    },
    async onSectionChange() {
      this.filters.course_offering_id = null; this.meta.courses = [];
      this.onCourseChange();
      if (!this.filters.teacher_id || !this.filters.section_id) return;
      
      this.loading.courses = true;
      try {
        const response = await this.api.get(`/teachers/${this.filters.teacher_id}/sections/${this.filters.section_id}/course-offerings`);
        this.meta.courses = response.data;
      } catch (error) { ElMessage.error('فشل في جلب المقررات.'); }
      finally { this.loading.courses = false; }
    },
    async onCourseChange() {
      this.gradesData = { assessments: [], students: [] };
      if (!this.filters.course_offering_id) return;

      this.loading.grades = true;
      try {
        const response = await this.api.get(`/course-offerings/${this.filters.course_offering_id}/grades`);
        this.gradesData = response.data;
      } catch (error) { ElMessage.error('فشل في جلب الدرجات.'); }
      finally { this.loading.grades = false; }
    },

    printGrades() {
        const logoUrl = `${window.location.origin}/logo-school-one.png`;
        const tableHeaders = `<tr><th>اسم الطالب</th>${this.gradesData.assessments.map(a => `<th>${a.title} (${a.max_score})</th>`).join('')}</tr>`;
        const tableRows = this.gradesData.students.map(student => `<tr><td>${student.name}</td>${this.gradesData.assessments.map(a => `<td>${student.scores[a.id] !== undefined ? student.scores[a.id] : '-'}</td>`).join('')}</tr>`).join('');

        const selectedYear = this.meta.studyYears.find(y => y.id === this.filters.study_year_id)?.name;
        const selectedTeacher = this.meta.teachers.find(t => t.id === this.filters.teacher_id)?.name;
        const selectedClass = this.meta.classes.find(c => c.id === this.filters.class_id)?.name;
        const selectedSection = this.meta.sections.find(s => s.id === this.filters.section_id)?.name;
        const selectedCourse = this.meta.courses.find(c => c.id === this.filters.course_offering_id)?.subject.name;

        const printContent = `
            <html>
                <head>
                    <title>Grades Report</title>
                    <style>
                        @import url('https://fonts.googleapis.com/css2?family=Tajawal:wght@400;700&display=swap');
                        body { font-family: 'Tajawal', sans-serif; direction: rtl; }
                        .report-container { width: 95%; margin: auto; }
                        .report-header { text-align: center; margin-bottom: 20px; border-bottom: 2px solid #002d55; padding-bottom: 15px; }
                        .report-header img { max-width: 120px; }
                        .report-header h1 { margin: 5px 0; color: #002d55; }
                        .report-details { margin-bottom: 20px; font-size: 14px; }
                        table { width: 100%; border-collapse: collapse; font-size: 12px; }
                        th, td { border: 1px solid #ccc; padding: 8px; text-align: center; }
                        th { background-color: #f2f2f2; color: #333; }
                        tr:nth-child(even) { background-color: #f9f9f9; }
                        td:first-child { text-align: right; font-weight: bold; }
                        @media print { body { -webkit-print-color-adjust: exact; print-color-adjust: exact; } }
                    </style>
                </head>
                <body>
                    <div class="report-container">
                        <div class="report-header">
                            <img src="${logoUrl}" alt="School Logo" />
                            <h1>كشف درجات الطلاب</h1>
                        </div>
                        <div class="report-details">
                            <p><strong>السنة الدراسية:</strong> ${selectedYear || ''} | <strong>المعلم:</strong> ${selectedTeacher || ''}</p>
                            <p><strong>الفصل:</strong> ${selectedClass || ''} | <strong>الشعبة:</strong> ${selectedSection || ''} | <strong>المقرر:</strong> ${selectedCourse || ''}</p>
                        </div>
                        <table>
                            <thead>${tableHeaders}</thead>
                            <tbody>${tableRows}</tbody>
                        </table>
                    </div>
                </body>
            </html>
        `;

        const printWindow = window.open('', '_blank');
        printWindow.document.write(printContent);
        printWindow.document.close();
        printWindow.focus();
        setTimeout(() => { printWindow.print(); printWindow.close(); }, 500);
    }
  }
};
</script>

<style scoped>
.grades-view-container { padding: 20px; }
.filter-card {
  background-color: #fcfcfc;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #e9e9eb;
  margin-bottom: 20px;
}
.filter-section .el-select {
  width: 100%;
}
.filter-section label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #606266;
  font-size: 14px;
}
.actions-toolbar {
  margin-bottom: 20px;
  display: flex;
  gap: 10px;
}
.loading-placeholder, .empty-placeholder {
  text-align: center;
  color: #888;
  margin-top: 40px;
  font-size: 16px;
}
</style>